<template>
    <div class="container-fluid espacio">
        <CNoSeEncontraronResultados v-if="!this.campoRequeridoEsValido(enlaces)" :opciones="{ tituloBusqueda: 'Búsqueda en enlaces', NombreSeccion: 'Enlaces' }"></CNoSeEncontraronResultados>
        <div v-if="this.campoRequeridoEsValido(enlaces)">
            <div class="titulo-contenedor">
                <h3 v-if="opciones.conTitulo.mostrar" :style="opciones.estilosCss">{{ opciones.conTitulo.texto }}</h3>
            </div>
            <div id="seccion-enlaces">
                <div class="row">
                    <div v-for="(enlace,index) in enlaces" :key="'ce' + index" class="form-inline enlaces col-xs-2 col-sm-2 col-md-2 col-lg-2 pt-2 pr-1">
                        <a v-if="enlace.EsArchivo" :href="`${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${ enlace.RutaParaAccesar }`">
                            <i class="fas fa-arrow-right mr-2"></i>{{ enlace.Titulo }}
                        </a>
                        <a v-if="campoRequeridoEsValido(enlace.RutaParaAccesar)&& enlace.RutaParaAccesar.includes('http') && !enlace.EsArchivo" target="_blank" :href="enlace.RutaParaAccesar">
                            <i class="fas fa-arrow-right mr-2"></i>{{ enlace.Titulo }}
                        </a>
                        <router-link v-else-if="campoRequeridoEsValido(enlace.RutaParaAccesar) && !enlace.EsArchivo" :to="enlace.RutaParaAccesar">
                            <i class="fas fa-arrow-right mr-2"></i>{{ enlace.Titulo }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CNoSeEncontraronResultados from '../Comun/CNoSeEncontraronResultados.vue'
import api from '@/../static/js/api'

export default {
    props: {
        idContenedor: {
            type: Number,
            default: 0
        },
        enlaces: {
            type: Array,
            default: () => []
        },
        opciones: {
            type: Object,
            default: () => ({ 
                conTitulo: { mostrar: false, texto: 'Titulo', estilosCss: '' }
            })
        },
    },
    components: {
        CNoSeEncontraronResultados: CNoSeEncontraronResultados
    },
    data() {
        return {
            api
        }
    },
    methods: {
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'array' || campo instanceof Array) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo.length > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        }
    },
    created() {
        console.log('enlaces::', this.enlaces);
    },
    computed: {
        obtenrUrlArea() {
            return this.$route.path;
        }
    }
}
</script>
<style scoped>
.titulo-contenedor {
    border: 1px solid #A4A0A0;
    color: white;
    background-color: rgb(59, 59, 59);
    padding: 5px 10px 0px 25px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}

#seccion-enlaces {
    border: 1px solid #A4A0A0;
    border-top: none;
    padding: 0.5em 1.5em 1em 1.5em;
}

.enlaces {
    color: #0086BF;
}

.enlaces a {
    font-size: 2.4vmin;
    font-weight: bold;
    color: #3b3b3b;
}

.enlaces a:hover, .enlaces a:focus {
    color: #be9a5e;
}

.titulo-contenedor h3 {
    font-weight: bold;
    font-size: 3.5vmin;
}

.espacio {
    padding: 5vmin 16vmin 5vmin 16vmin;
}

.espacio-superior {
    padding-top: 2em;
}

.espacio-inferior {
    padding-top: 2em;
}

.espacio-derecho {
    padding-top: 2em;
}

.espacio-izquierdo {
    padding-top: 2em;
}
</style>


// WEBPACK FOOTER //
// src/components/Intranet/Formatos/CContenedorEnlaces.vue